import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, BehaviorSubject, of, Subscription } from 'rxjs';
import { map, catchError, switchMap, finalize } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Injectable({
  providedIn: 'root'
})
export class WaiterService {
  httpClient = inject(HttpClient);
  loadingBar = inject(LoadingBarService)
  baseUrl = environment.baseApi
  private authLocalStorageToken = `user`;
  private authdetailsLocalStorageToken = `userdetails`;


  constructor() { }
  claimOrder(id: any, payload: any) {
    this.loadingBar.start();
    return this.httpClient.post(`${this.baseUrl}/orders/claim-order/${id}`, payload)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }

  viewUnclaimedOrder(params?: any) {
    let queryParams = new HttpParams();
    if (params) {
      if (params.date !== 'all') queryParams = queryParams.append('date', params.date);
      if (params.table !== 'all') queryParams = queryParams.append('table', params.table);
    }
    return this.httpClient.get(`${this.baseUrl}/orders/unclaimed`, { params: queryParams });
  }
  searchInventory(term: string, table_id: any, limit: number = 10): Observable<any> {
    const params = new HttpParams()
      .set('q', term)
      .set('limit', limit.toString())
      .set('table_id', table_id);

    return this.httpClient.get<any>(`${this.baseUrl}/inventories/search`, { params })
      .pipe(
        map(response => response.data),
        catchError(error => {
          console.error('Search error:', error);
          return of([]);
        })
      );
  }
  listActiveOrders(params?: any) {
    let queryParams = new HttpParams();
    if (params) {
      if (params.date !== 'all') queryParams = queryParams.append('date', params.date);
      if (params.table !== 'all') queryParams = queryParams.append('table', params.table);
      if (params.status !== 'all') queryParams = queryParams.append('status', params.status);
    }
    return this.httpClient.get(`${this.baseUrl}/orders/active-waiter-orders`, { params: queryParams });
  }
  listCompletedOrders(params?: any) {
    let queryParams = new HttpParams();
    if (params) {
      if (params.date !== 'all') queryParams = queryParams.append('date', params.date);
      if (params.table !== 'all') queryParams = queryParams.append('table', params.table);
    }
    return this.httpClient.get(`${this.baseUrl}/orders/completed-waiter-orders`, { params: queryParams });
  }

  viewOrder(id: any) {
    this.loadingBar.start();
    return this.httpClient.get(`${this.baseUrl}/orders/show/${id}`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  getActiveWaiters() {
    this.loadingBar.start();
    return this.httpClient.get(`${this.baseUrl}/orders/active-waiters-all`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  transferOrder(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/orders/transfer-waiter-orders`, data);
  }
  getOrderDetails(orderId: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/orders/show/${orderId}`);
  }
  processReturn(returnData: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/orders/return-item`, returnData);
  }
  fetchAllNotifications(page: number) {
    this.loadingBar.start();
    return this.httpClient.get(`${this.baseUrl}/notifications?page=${page}`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  markOrder(data: any) {
    this.loadingBar.start();
    return this.httpClient.post(`${this.baseUrl}/orders/mark-order`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  fetchWaiterRevenue(payload:any) {
    let body: any = {};

    switch (payload.filterType) {
        case 'today':
            body.startDate = payload.startDate;  // Today's date
            body.endDate = payload.startDate;
            break;
        case 'yesterday':
            body.startDate = payload.startDate;  // Yesterday's date
            body.endDate = payload.startDate;
            break;
        case 'weekly':
            body.startDate = payload.startDate;  // First day of the week
            body.endDate = payload.endDate;      // Today's date
            break;
        case 'monthly':
            body.startDate = payload.startDate;  // First day of the month
            body.endDate = payload.endDate;      // Today's date
            break;
        case 'custom':
            if (payload.startDate && payload.endDate) {
                body.startDate = payload.startDate;
                body.endDate = payload.endDate;
            }
            break;
        default:
            // If no filterType is set, fetch all revenue records
            break;
    }

    console.log('Sending request with:', body);
    return this.httpClient.post(`${this.baseUrl}/orders/waiter-revenue`, body);
}

  fetchWaiterTransactions(payload:any) {
    let body: any = { page: payload.page };

    switch (payload.filterType) {
        case 'today':
            body.startDate = payload.startDate;  // Today's date
            body.endDate = payload.startDate;
            break;
        case 'yesterday':
            body.startDate = payload.startDate;  // Yesterday's date
            body.endDate = payload.startDate;
            break;
        case 'weekly':
            body.startDate = payload.startDate;  // First day of the week
            body.endDate = payload.endDate;      // Today's date
            break;
        case 'monthly':
            body.startDate = payload.startDate;  // First day of the month
            body.endDate = payload.endDate;      // Today's date
            break;
        case 'custom':
            if (payload.startDate && payload.endDate) {
                body.startDate = payload.startDate;
                body.endDate = payload.endDate;
            }
            break;
        default:
            // If no filterType is set, fetch all transactions
            break;
    }

    console.log('Sending request with:', body);
    return this.httpClient.post(`${this.baseUrl}/orders/waiter-transactions`, body);
}
fetchMonicreditTransactions(payload:any) {
  let body: any = { page: payload.page };

  switch (payload.filterType) {
      case 'today':
          body.startDate = payload.startDate;  // Today’s date
          body.endDate = payload.startDate;
          break;
      case 'yesterday':
          body.startDate = payload.startDate;  // Yesterday’s date
          body.endDate = payload.startDate;
          break;
      case 'weekly':
          body.startDate = payload.startDate;  // First day of the week
          body.endDate = payload.endDate;      // Today’s date
          break;
      case 'custom':
          if (payload.startDate && payload.endDate) {
              body.startDate = payload.startDate;
              body.endDate = payload.endDate;
          }
          break;
      default:
          // If no filterType is set, fetch all transactions
          break;
  }

  console.log('Sending request with:', body);
  return this.httpClient.post(`${this.baseUrl}/monicredit-transactions?page=${body.page}`, body);
}
  returnItem(data: any) {
    this.loadingBar.start();
    return this.httpClient.post(`${this.baseUrl}/orders/return-item`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }

  addItems(data: any, id: any) {
    this.loadingBar.start()
    return this.httpClient.patch(`${this.baseUrl}/orders/add-item/${id}`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }

  initiatePayment(data: any) {
    this.loadingBar.start()
    return this.httpClient.post(`${this.baseUrl}/orders/initiate-payment`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  listNotifications() {
    this.loadingBar.start()
    return this.httpClient.get(`${this.baseUrl}/notifications`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  readNotification(id: any) {
    this.loadingBar.start()
    return this.httpClient.get(`${this.baseUrl}/notifications/read/${id}`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }

  storeOrder(data: any) {
    this.loadingBar.start()
    return this.httpClient.post(`${this.baseUrl}/orders/store`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  fetchAllCategories() {
    this.loadingBar.start()
    return this.httpClient.get(`${this.baseUrl}/inventories/categories`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  fetchInventories(page: any, category_id: any, table_id: any) {
    this.loadingBar.start()
    return this.httpClient.get(`${this.baseUrl}/inventories?page=${page}&category=${category_id}&table_id=${table_id}`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  fetchCategoryDetails(id: any) {
    this.loadingBar.start()
    return this.httpClient.get(`${this.baseUrl}/inventories/show-category/${id}`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  listBarcodes() {
    this.loadingBar.start()
    return this.httpClient.get(`${this.baseUrl}/barcode-management`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }

  fetchChatHistory(order_id: any) {
    this.loadingBar.start()
    let payload = {
      order_id: order_id
    }
    return this.httpClient.post(`${this.baseUrl}/orders/chat-history`, payload)
      .pipe(finalize(() => { this.loadingBar.stop(); }))

  }
  sendChatMessage(order_id: any, message: any) {
    this.loadingBar.start()
    let payload = {
      order_id: order_id,
      message: message
    }
    return this.httpClient.post(`${this.baseUrl}/orders/chat-customer`, payload)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }

  setOrderDelay(data: any) {
    this.loadingBar.start()
    return this.httpClient.post(`${this.baseUrl}/set-order-delay`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }

  closeOrder(orderId: string) {
    return this.httpClient.post(`${this.baseUrl}/orders/close-order`, {
      order_id: orderId
    });
  }
}
